<template>
    <div>
      <p>Select to witch audience you would like to send mail shot.</p>
      <select-audience @selected="onSelectedListing"/>

      <h4 v-if="0 !== listings.length">Selected Audience</h4>

      <selected-audience
        v-if="0 !== listings.length"
        :listings="listings"
        @removed="onListingRemoved"
      />

      <b-button v-on:click="onAudienceNext">
        Next
      </b-button>
    </div>
</template>

<script>
    import SelectAudience from "./SelectAudience";
    import SelectedAudience from "./SelectedAudience";
    export default {
      name: "AudienceTab",
      components: {
        SelectedAudience,
        SelectAudience
      },
      props: {
          listings: {
            type: Array,
            default: new Array(),
          }
        },
        methods: {
          onListingRemoved(data) {
            this.listings = this.listings.filter(function(listing) {
              return data.id !== listing.id;
            });
          },
          onSelectedListing(listing) {
            let inList = false;
            this.listings.forEach(value => {
              if (value.id === listing.id) {
                inList = true;
              }
            });

            if (!inList) {
              this.listings.push(listing);
            }
          },
          onAudienceNext() {
            this.$emit('click', this.listings);
          },
        }
    }
</script>

<style scoped>

</style>
